import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { frontendURL } from '../../../helper/URLHelper';

const KnowledgeBase = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/knowledge-base'),
      name: 'knowledge_base_index',
      meta: {
        permissions: ['administrator'],
        featureFlag: FEATURE_FLAGS.KNOWLEDGE_BASE,
      },
      component: KnowledgeBase,
    },
  ],
};
